import * as franchisePageActions from '../../action_creators/franchise/franchise_page_data_action_creators';
import log from '../../../services/logger_service';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import get from 'lodash/get';
import FranchisePageModel from '../../../models/franchise/franchise_page_model';
import axios from 'axios';
import https from 'https';

const sourceMap = {
  'next-big-things-in-tech/2021': `https://airtablemgr.mansueto.com/franchise/nbtt-2021`,
  'q50-2022': `https://airtablemgr.mansueto.com/franchise/q50-2022`,
  'q50-2023': `https://airtablemgr.mansueto.com/franchise/q50-2023`,
  'q50-2024': `https://airtablemgr.mansueto.com/franchise/q50-2024`,
  'mcp-2022': `https://airtablemgr.mansueto.com/franchise/mcp-2022`,
  'mcp-2023': `https://airtablemgr.mansueto.com/franchise/mcp-2023`,
  'bwi-2022': `https://airtablemgr.mansueto.com/franchise/bwi-2022`,
  'bwi-2023': `https://airtablemgr.mansueto.com/franchise/bwi-2023`,
  'ibd-2022-2': `https://airtablemgr.mansueto.com/franchise/ibd-2022`,
  'ibd-2023': `https://airtablemgr.mansueto.com/franchise/ibd-2023`,
  'btm-2023': `https://airtablemgr.mansueto.com/franchise/btm-2023`,
  creator25:
    'https://assets.fastcompany.com/multisite_files/fastcompany/creator-25/2022_c25_records.json',
  'next-big-things-in-tech/list': `https://airtablemgr.mansueto.com/franchise/nbtt-2025`,
  'next-big-things-in-tech/2024': `https://airtablemgr.mansueto.com/franchise/nbtt-2024`,
  'next-big-things-in-tech/2023': `https://airtablemgr.mansueto.com/franchise/nbtt-2023`,
  'next-big-things-in-tech/2022': `https://airtablemgr.mansueto.com/franchise/nbtt-2022`,
  'ibd-2024': `https://airtablemgr.mansueto.com/franchise/ibd-2024`,
  'ibd-2025': `https://airtablemgr.mansueto.com/franchise/ibd-2025`,
  'bwi-2024': `https://airtablemgr.mansueto.com/franchise/bwi-2024`,
  'bwi-2025': `https://airtablemgr.mansueto.com/franchise/bwi-2025`
};

function getExternalList(params) {
  const { slug } = params;
  const httpsAgent = new https.Agent({
    rejectUnauthorized: false
  });
  const url = sourceMap[slug];

  if (slug === 'next-big-things-in-tech/list') {
    return axios.get(url, {
      headers: { 'User-Agent': 'axios/mv-webapp' }
    });
  }

  return url !== undefined
    ? axios.get(url, {
        httpsAgent
      })
    : Promise.resolve(null);
}

function fetchFranchisePageData(params, store) {
  return FranchisePageModel.fetch(params, store)
    .then(function handleFranchisePageData(FranchisePageData) {
      return FranchisePageData;
    })
    .catch(function handleUserError(err) {
      if (err.message === 'Invalid Year') {
        log.warn('User tried a World Changing Ideas page with invalid year.');
        return false;
      }
      log.warn('Something went wrong loading World Changing Ideas.');
      return false;
    });
}

function getFranchiseCategory(params) {
  const { slug } = params;
  switch (slug) {
    case 'q50-2022':
      return 'queer-50';

    default:
      return slug;
  }
}

function formatFranchiseSlug(params) {
  const { slug } = params;
  switch (slug) {
    case 'next-big-things-in-tech/list':
      return 'next-big-things-in-tech-list';

    case 'next-big-things-in-tech/2024':
      return 'next-big-things-in-tech-2024';

    default:
      return slug;
  }
}
export default function fetchFranchisePage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(franchisePageActions.franchisePageLoading({}, store));

    const { slug } = params;
    const foundUrl = sourceMap[slug];

    const asyncActions = [
      fetchFranchisePageData(params, store),
      asyncRecircFeedActions(params, store)(dispatch),
      getExternalList(params, store)
    ];

    return Promise.all(asyncActions)
      .then(function handlePostDetailData(data) {
        const pageData = get(data, '[0].data', {});
        const pageType = get(pageData, 'type', '')
          ? `${get(pageData, 'type', '')}-${get(pageData, 'slug', '')}`
          : formatFranchiseSlug(params);
        if (foundUrl.startsWith('https://airtablemgr.mansueto.com/')) {
          pageData.externalList = get(data, '[2].data.data', null);
        } else {
          pageData.externalList = get(data, '[2].data', null);
        }
        pageData.franchiseCategory = getFranchiseCategory(params);
        pageData.year = /\b\d{4}\b/.test(get(pageData, 'slug', ''));
        dispatch(
          franchisePageActions.franchisePageLoaded(pageData, store, pageType)
        );
        return pageData;
      })
      .catch(function handleUserError(err) {
        dispatch(franchisePageActions.franchisePageLoadError(err, store));
        return log.error(
          err,
          `Error in Franchise page actions, message: ${err.message}`
        );
      });
  };
}
